{
    "NavigationNext": "Próximo",
    "NavigationPrevious": "Anterior",
    "ApplicationUservoice": "https:\/\/akixi.uservoice.com",
    "ApplicationDefaultDirectory": "\/CCS\/Estilos\/Imagens\/Akixi2019\/",
    "NAME": "LanguageGeneral"
}